import React, { useState, useContext } from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';

import HeaderStyles from './header-styles';
import MegaMenu from './mega-menu';
import Cart from '../cart';
import CartOverlay from '../cart/cart-overlay';
import Wrapper from '../elements/wrapper';
import { AnimatePresence } from 'framer-motion';
import Hamburger from 'hamburger-react';
import { createGlobalStyle } from 'styled-components';

import { StoreContext } from '../../context/StoreContext';

import Logo from '../../images/logo.inline.svg';

import HeartIcon from '../../images/icons/heart.inline.svg';
import CartIcon from '../../images/icons/carticon.inline.svg';
import AccountIcon from '../../images/icons/account.inline.svg';
import MobileMenu from './mobile-menu';

const primaryLinks = [
    {
        title: 'Shop',
        url: '#',
    },
    {
        title: 'Featured',
        url: '/pages/featured',
    },
    {
        title: 'Weddings',
        url: '/pages/weddings',
    },
    {
        title: 'Branded',
        url: '/pages/branded-category',
    },
];

const primaryMMNav = [
    {
        title: 'Shop All',
    },
    {
        title: 'Decor',
    },
    {
        title: 'Apparel',
    },
    {
        title: 'Face Masks',
    },
    {
        title: 'Weddings',
    },
];

const mobileNav = [
    {
        title: 'Shop',
        url: '#',
    },
    {
        title: 'Featured',
        url: '/pages/featured',
    },
    {
        title: 'Weddings',
        url: '/pages/weddings',
    },
    {
        title: 'Branded',
        url: '/branded',
    },
];

const Header = ({ siteTitle }) => {
    const data = useStaticQuery(graphql`
        query {
            header: allWpHeadlessOption(filter: { slug: { eq: "header" } }) {
                edges {
                    node {
                        id
                        title
                        mega_menu_acf {
                            shopAllTab {
                                shopAllLinks {
                                    link {
                                        title
                                        url
                                    }
                                }

                                shopAllLinks {
                                    link {
                                        title
                                        url
                                    }
                                }
                                shopAllFeaturedContentLink {
                                    title
                                    url
                                }
                                shopAllFeaturedContentImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 900) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }

                            homeDecorTab {
                                homeDecorLinks {
                                    link {
                                        title
                                        url
                                    }
                                }
                                homeDecorFeaturedContentLink {
                                    title
                                    url
                                }
                                homeDecorFeaturedContentImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 900) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }
                            apparelTab {
                                apparelLinks {
                                    link {
                                        title
                                        url
                                    }
                                }
                                apparelFeaturedContentLink {
                                    target
                                    title
                                    url
                                }
                                apparelFeaturedContentImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 900) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }
                            masksTab {
                                masksLinks {
                                    link {
                                        title
                                        url
                                    }
                                }
                                masksFeaturedContentLink {
                                    title
                                    url
                                }
                                masksFeaturedContentImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 900) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                            }
                            weddingsTab {
                                weddingsLinks {
                                    link {
                                        title
                                        url
                                    }
                                }
                                weddingsFeaturedContentImage {
                                    localFile {
                                        childImageSharp {
                                            fluid(maxWidth: 900) {
                                                ...GatsbyImageSharpFluid
                                            }
                                        }
                                    }
                                }
                                weddingsFeaturedContentLink {
                                    title
                                    url
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const { mega_menu_acf } = (data && data.header.edges[0].node) || {};

    // links
    let shopAllLinks = mega_menu_acf.shopAllTab.shopAllLinks;
    let homeDecorLinks = mega_menu_acf.homeDecorTab.homeDecorLinks;
    let apparelLinks = mega_menu_acf.apparelTab.apparelLinks;
    let masksLinks = mega_menu_acf.masksTab.masksLinks;
    let weddingsLinks = mega_menu_acf.weddingsTab.weddingsLinks;

    // featured image + link

    // -- shop all
    let shopAllFeatImage =
        mega_menu_acf.shopAllTab.shopAllFeaturedContentImage.localFile
            .childImageSharp.fluid;
    let shopAllFeatLink = mega_menu_acf.shopAllTab.shopAllFeaturedContentLink;

    //  -- home decor
    let homeDecorFeatImage =
        mega_menu_acf.homeDecorTab.homeDecorFeaturedContentImage &&
        mega_menu_acf.homeDecorTab.homeDecorFeaturedContentImage.localFile
            .childImageSharp.fluid;
    let homeDecorFeatLink =
        mega_menu_acf.homeDecorTab.homeDecorFeaturedContentLink;

    //  -- apparel
    let apparelFeatImage =
        mega_menu_acf.apparelTab.apparelFeaturedContentImage.localFile
            .childImageSharp.fluid;
    let apparelFeatLink = mega_menu_acf.apparelTab.apparelFeaturedContentLink;

    //  -- masks
    let masksFeatImage =
        mega_menu_acf.masksTab.masksFeaturedContentImage.localFile
            .childImageSharp.fluid;
    let masksFeatLink = mega_menu_acf.masksTab.masksFeaturedContentLink;

    //  -- weddings
    let weddingsFeatImage =
        mega_menu_acf.weddingsTab.weddingsFeaturedContentImage &&
        mega_menu_acf.weddingsTab.weddingsFeaturedContentImage.localFile
            .childImageSharp.fluid;
    let weddingsFeatLink =
        mega_menu_acf.weddingsTab.weddingsFeaturedContentLink;

    const subNavs = [
        {
            links: shopAllLinks,
            feat_content: {
                image: shopAllFeatImage,
                link: shopAllFeatLink,
            },
        },
        {
            links: homeDecorLinks,
            feat_content: {
                image: homeDecorFeatImage,
                link: homeDecorFeatLink,
            },
        },
        {
            links: apparelLinks,
            feat_content: {
                image: apparelFeatImage,
                link: apparelFeatLink,
            },
        },
        {
            links: masksLinks,
            feat_content: {
                image: masksFeatImage,
                link: masksFeatLink,
            },
        },
        {
            links: weddingsLinks,
            feat_content: {
                image: weddingsFeatImage,
                link: weddingsFeatLink,
            },
        },
    ];
    const [isMobileMenuShowing, setIsMobileMenuShowing] = useState(false);
    const [isMegaMenuShowing, setIsMegaMenuShowing] = useState(false);
    const [subNavActive, setSubNavActive] = useState(0);
    const { toggleCartOpen, isCartOpen, toggleCartClose } = useContext(
        StoreContext
    );

    function handleMegaMenu(value) {
        if (value === 'has-children') {
            setIsMegaMenuShowing(true);
        } else {
            setIsMegaMenuShowing(false);
        }
    }

    function handleCartToggle() {
        if (isCartOpen) {
            toggleCartClose();
        } else {
            toggleCartOpen();
        }
    }

    const GlobalStyle = createGlobalStyle`
        html {
        overflow-y: ${isMobileMenuShowing ? 'hidden' : ''};
        }
        
`;

    return (
        <div onMouseLeave={() => setIsMegaMenuShowing(false)}>
            <HeaderStyles>
                <GlobalStyle />
                <Wrapper className="header-wrapper">
                    <div className="logo-container">
                        <Link to="/">
                            <Logo />
                        </Link>
                    </div>
                    <div className="primary-nav-container">
                        <nav className="primary-nav">
                            <ul>
                                {primaryLinks &&
                                    primaryLinks.map((link, index) => {
                                        const { url, title } = link;
                                        if (index === 0) {
                                            return (
                                                <li key={index}>
                                                    <Link
                                                        className={
                                                            isMegaMenuShowing
                                                                ? 'has-children active'
                                                                : 'has-children'
                                                        }
                                                        to={url}
                                                        onMouseEnter={() =>
                                                            handleMegaMenu(
                                                                'has-children'
                                                            )
                                                        }
                                                    >
                                                        {title}
                                                    </Link>
                                                </li>
                                            );
                                        } else {
                                            return (
                                                <li key={index}>
                                                    <Link
                                                        onMouseEnter={() =>
                                                            handleMegaMenu()
                                                        }
                                                        to={link.url}
                                                    >
                                                        {title}
                                                    </Link>
                                                </li>
                                            );
                                        }
                                    })}
                            </ul>
                        </nav>
                    </div>
                    <div className="secondary-nav-container">
                        <nav className="secondary-nav">
                            <ul>
                                <li>
                                    <Link to="/pages/fighting-climate-change">
                                        Impact
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/accounts/dashboard/wishlist">
                                        <HeartIcon />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/accounts/dashboard">
                                        <AccountIcon />
                                    </Link>
                                </li>
                                <li className="cart-li">
                                    <button onClick={() => handleCartToggle()}>
                                        <CartIcon />
                                    </button>
                                </li>
                            </ul>
                        </nav>
                        <nav className="mobile-nav">
                            <ul>
                                <li>
                                    <Link to="/accounts/dashboard">
                                        <AccountIcon />
                                    </Link>
                                </li>
                                <li>
                                    <button onClick={() => handleCartToggle()}>
                                        <CartIcon />
                                    </button>
                                </li>
                                <li className="hamburger-container">
                                    <Hamburger
                                        size={23}
                                        toggled={isMobileMenuShowing}
                                        toggle={setIsMobileMenuShowing}
                                    />
                                </li>
                            </ul>
                        </nav>
                    </div>
                </Wrapper>
                {isMegaMenuShowing && (
                    <MegaMenu
                        primaryLinks={primaryLinks}
                        primaryMMNav={primaryMMNav}
                        subNavs={subNavs}
                        subNavActive={subNavActive}
                        setSubNavActive={setSubNavActive}
                    />
                )}
            </HeaderStyles>
            <AnimatePresence>{isCartOpen && <Cart />}</AnimatePresence>
            <AnimatePresence>{isCartOpen && <CartOverlay />}</AnimatePresence>
            <AnimatePresence>
                {isMobileMenuShowing && (
                    <MobileMenu
                        primaryLinks={mobileNav}
                        shopAllLinks={primaryMMNav}
                        subNavLinks={subNavs}
                    />
                )}
            </AnimatePresence>
        </div>
    );
};

export default Header;
